import request from '@/utils/request';

// 获取列表
export function List(params) {
    return request({
        url: '/bayley/screening/report/page',
        method: 'GET',
        params: params
    });
}

// 关联数据
export function Binding(params) {
    return request({
        url: '/bayley/screening/report/binding',
        method: 'GET',
        params: params
    });
}

// 导入数据
export function ImportData(data) {
    return request({
        url: '/bayley/screening/report/importData',
        method: 'POST',
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

// 导出数据
export function ExportData(params) {
    return request({
        url: '/bayley/screening/report/exportData',
        method: 'GET',
        params: params,
        responseType: 'blob'
    });
}

